import { DisplayTypeOptions } from '@Modules/ui_module';
import { CacheOptions } from '@Shared/cache';
export interface Auth0Options {
  domain: string;
  clientId: string;
  callbackURL: string;
  logout: Auth0LogoutOptions;
  isTrib?: boolean;
  checkSessionCache?: CheckSessionOptions;
  mode: Auth0ModeOptions;
  useSessionServer: boolean;
}
export interface Auth0OptionsBase {
  type: AuthMode;
}

export interface CheckSessionOptions {
  useCache: boolean;
  cacheOptions?: CacheOptions;
}

export interface Auth0LogoutOptions {
  redirectUri: string;
  //Have this for obits so I can send them directly to /logout which handles any logout processes and then redirects to the redirectUri
  clearServerCache?: boolean;
}

export interface Auth0RedirectOptions {
  redirectUri: string;
  returnUrl?: string;
  showProcessingScreen?: boolean;
}

export enum AuthMode {
  Embedded = 'embedded',
  Redirect = 'redirect',
  Popup = 'popup',
}

export type Auth0ModeOptions =
  | (Auth0OptionsBase & { type: AuthMode.Embedded } & {
      options: { display: DisplayTypeOptions; reloadOnAuth?: boolean };
    }) // Embedded with displayType and reload option
  | (Auth0OptionsBase & { type: AuthMode.Redirect | AuthMode.Popup } & {
      options: Auth0RedirectOptions;
    });
